import { itemSlipNextNoGetApi } from "src/domain/api/itemSlip/itemSlipNextNoGetApi"

type PayloadShape = Parameters<typeof itemSlipNextNoGetApi>[0]
export async function itemSlipNextNoGetService(
	payload: PayloadShape,
	token: string | null,
) {
	return await itemSlipNextNoGetApi(payload, token)
}
